var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useFetch, usePromise } from '@rad/hooks';
import { getConst } from '@rad/utility/http';
import { createTourInviteView, getTourInvites, revokeTourInvite } from '../../../../common/network/tour';
import { propertyUrls } from '../../../../common/routes/urls/general';
import { useToast } from '../../../../contexts/toast';
// A tour's invites and what the admin can do about them, for the wizard's Homes step and the tour's
// Homeowner invites screen alike. Newest first, so the first that names a house's property is the one
// shown for it. Null tourId (a tour not saved yet) has none.
export const useTourInvites = (tourId) => {
    const toast = useToast();
    const [invitesPromise, reload] = useFetch(tourId === null ? getConst([]) : getTourInvites(tourId));
    const invites = usePromise(invitesPromise);
    const [busy, setBusy] = useState(false);
    const forHouse = (house) => { var _a; return (_a = invites === null || invites === void 0 ? void 0 : invites.find(invite => invite.propertyIds.includes(house.propertyId))) !== null && _a !== void 0 ? _a : null; };
    // What the work answers once it is done and the list is being read again; null when it failed, which
    // the app has already said.
    const act = (work, done) => __awaiter(void 0, void 0, void 0, function* () {
        setBusy(true);
        try {
            const result = yield work();
            toast.success(done);
            reload();
            return result;
        }
        catch (_a) {
            return null;
        }
        finally {
            setBusy(false);
        }
    });
    const revoke = (tourId, invite) => act(() => revokeTourInvite(tourId, invite.id), 'Invite cancelled');
    // The view, and the stop on the house as it now reads, showing it.
    const createView = (tourId, invite) => { var _a; return act(() => createTourInviteView(tourId, invite.id), `${(_a = invite.homeowner) !== null && _a !== void 0 ? _a : invite.email}'s page is on the tour`); };
    return { invites, reload, busy, act, forHouse, revoke, createView };
};
export const stageOf = (invite) => invite === null ? 'none'
    : invite.viewId !== null ? 'featured'
        : invite.accepted === null ? 'invited'
            : invite.contributed ? 'contributed'
                : 'accepted';
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
// What the homeowner has added, as counts worth saying: "3 photos · 2 timeline entries".
export const addedSummary = (invite) => [
    invite.photos > 0 ? plural(invite.photos, 'photo', 'photos') : '',
    invite.timeline > 0 ? plural(invite.timeline, 'timeline entry', 'timeline entries') : '',
    invite.people > 0 ? plural(invite.people, 'person', 'people') : '',
].filter(part => part !== '').join(' · ') || 'details';
// The homeowner's page, with what the tour team can do with it. Null until the homeowner has accepted.
export const reviewUrl = (invite) => invite.propertyId === null ? null : `${propertyUrls.property.getURL({ id: invite.propertyId })}?review=${invite.id}`;
